module.exports = __webpack_public_path__ + "img/co-branding-world-JET-4.e3e20592.png";